module.exports = __webpack_public_path__ + "static/media/parent.a567037e.svg";